import {Component, Input, OnInit, ViewChild, Renderer2, ElementRef, AfterViewInit} from '@angular/core';
import {CommunicationService} from '../../services/communication.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginResult, LoginService} from '../../services/login.service';
import {SignInComponent} from './sign-in/sign-in.component';
import {SCREEN_SIZE, SocialType} from '../../classes/enums';
import { PreRenderService } from '../../services/pre-render.service';
import { PostAuthenticationService } from '../../services/post-authentication.service';
import { LoginSource } from '../../classes/enums';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { OFFMARKET_LOGIN } from '../../classes/analytics-tags';
import { DomManipulationService } from '../../services/dom-manipulation/dom-manipulation.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    './login.component.scss',
    './login.component.desktop.scss'
  ],
  animations: [
    trigger('trigger', [
      transition(':enter', [
        style({height: '0'}),
        animate('300ms', style({height: '*'}))
      ]),
      transition(':leave', [
        style({height: '*'}),
        animate('300ms', style({height: '0'}))
      ])
    ])
  ]
})
export class LoginComponent implements OnInit, AfterViewInit {
  @Input() disableAnimation: boolean = false;
  @Input() loginSource: LoginSource = LoginSource.Generic;

  show: boolean = true;
  showSignIn: boolean = true;
  showForgotPassword: boolean = false;
  email: string;
  accountsAvailable: Array<SocialType>;
  LoginSource = LoginSource;
  @ViewChild('signIn') signIn: SignInComponent;
  @ViewChild('signInContainer') signInContainerRef: ElementRef;

  constructor(private communicationService: CommunicationService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private prerenderService: PreRenderService,
              private loginService: LoginService,
              private _analyticsService: AnalyticsService,
              private _postAuthenticationService: PostAuthenticationService,
              private renderer: Renderer2,
              private domManipulationService: DomManipulationService) {
    this.disableAnimation = this.communicationService.screenSize.getValue() >= SCREEN_SIZE.DESKTOP_UP;
  }

  ngOnInit() {
    this.prerenderService.setPreRenderFlag(200);
    const provider = this.activatedRoute.snapshot.queryParams.provider;
    this.setLoginSource();

    if (provider) {
      // Get the state param back from Facebook/Google where we saved the URL of the page the user was on when they logged in.
      const params = new URLSearchParams(this.activatedRoute.snapshot.fragment);
      this.doLogin(provider, false, params.get('state'));
    }

    this.loginService.accountsAvailable.subscribe((accountsAvailable) => {
      this.accountsAvailable = accountsAvailable;
    });
  }

  ngAfterViewInit() {
    this.domManipulationService.scrollToTop(this.signInContainerRef);
  }

  private setLoginSource () {
    this.loginSource = !!this.activatedRoute.snapshot.params.loginSource && Object.values(LoginSource).includes(this.activatedRoute.snapshot.params.loginSource) ?
    this.activatedRoute.snapshot.params.loginSource : this.loginSource;
  }

  private doLogin(provider: any, proceedWithSocial: boolean = false, returnToUrl: string) {
    const returnValues = new Map<string, string>();
    this.activatedRoute.snapshot.fragment.split('&').map(item => {
      const values = item.split('=');
      returnValues.set(values[0], values[1]);
    });
    const now = new Date();
    const tokenExpireDate = new Date(now.valueOf() + Number(returnValues.get('expires_in')) * 1000);
    if (returnValues.has('access_token') && returnValues.has('expires_in') && tokenExpireDate > new Date()) {
      // send the access_token to the server so it can be validated and used to get user's information
      this.loginService.socialLogin(returnValues.get('access_token'), provider, proceedWithSocial).subscribe((result) => {
        if (result === LoginResult.AccountsAvailable) {
          this.doLogin(this.activatedRoute.snapshot.queryParams.provider, true, '');
        } else if (result === LoginResult.LoggedIn) {
          const redirectTo = returnValues.has('state') ? returnValues.get('state') : returnToUrl.indexOf('/login') < 0 ? '' : returnToUrl;
          this.renderer.removeClass(document.querySelector('html'), 'no-scroll');
          if (this.loginSource == LoginSource.HomeEstimator) { 
            this._analyticsService.eventTrack(OFFMARKET_LOGIN, null);
          }
          this.router.navigate([decodeURIComponent(redirectTo)]);
        } else {
          this.renderer.removeClass(document.querySelector('html'), 'no-scroll');
          this.router.navigate(['/']);
        }
      });
    }
  }

  close() {
    this.renderer.removeClass(document.querySelector('html'), 'no-scroll');
    this._postAuthenticationService.removeSaveSearch();
    if (this.communicationService.screenSize.getValue() < SCREEN_SIZE.DESKTOP_UP) {
      if (this.activatedRoute.snapshot.queryParams.provider) {
        this.router.navigate(['/find-real-estate']);
      } else {
        // closing the popup by sending null
        this.router.navigate([{ outlets: { popup: null } }]);
        this.show = false;
      }
    } else {
      this.communicationService.navigation.toggleNavs.next({left: false, right: false});
    }
  }

  continueLogin(event) {
    this.doLogin(this.activatedRoute.snapshot.queryParams.provider, true, '');
  }

  forgotPassword(value) {
    this.showForgotPassword = value.show;
    this.showSignIn = !value.show;
    this.email = value.email;
  }

  animationCallback(event) {
    if (event.toState === 'void') {
      this.communicationService.showSignIn.next(false);
    }
  }
}
